import { subtitleFeatures } from "@/mocks/movies";

export default function ResourceSection() {
  return (
    <section id="resource" className="w-full px-4 md:px-8 py-12 md:py-16 bg-secondary-900">
      <div className="max-w-3xl">
        <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-800 text-primary-300 text-xs font-semibold">
          <i className="ri-server-line" aria-hidden="true" />
          字幕与资源
        </span>
        <h2 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-background-50">
          中文字幕 · 高清资源说明
        </h2>
        <p className="mt-2 text-sm text-background-200 leading-relaxed">
          为了让不同语言习惯的观众都能顺畅观看，八戒影院在片源整理、字幕配套与
          更新节奏上做了统一说明，方便你判断内容是否符合预期。
        </p>
      </div>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {subtitleFeatures.map((f) => (
          <div key={f.title} className="rounded-xl bg-secondary-800/70 border border-secondary-700 p-5 md:p-6">
            <div className="w-10 h-10 rounded-lg bg-primary-500 text-foreground-950 flex items-center justify-center">
              <i className={`${f.icon} text-xl`} aria-hidden="true" />
            </div>
            <h3 className="mt-4 font-heading text-base font-bold text-background-50">{f.title}</h3>
            <p className="mt-2 text-xs text-background-200 leading-relaxed">{f.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}